import React from 'react';
import { Button } from 'reactstrap';
import { IconEdit, IconRemove } from '../../Icons/Icons';
import './EditBar.css';

export const EditBar = ({
  toggleEditing,
  removeContentBlock,
  className,
  editLabel
}) => (
  <div className={`${className || 'edit-bar'}`}>
    <Button color="primary" size="sm" onClick={toggleEditing}>
      <IconEdit />
      <span>{editLabel ? editLabel : 'Edit'}</span>
    </Button>
    <Button outline color="primary" size="sm" onClick={removeContentBlock}>
      <IconRemove />
      <span>Remove</span>
    </Button>
  </div>
);

export default EditBar;



// WEBPACK FOOTER //
// ./src/components/landingPage/EditBar/EditBar.js